import { BooleanValue } from '@coveo/bueno';
import { createAction } from '@reduxjs/toolkit';
import { validatePayload } from '../../../utils/validate-payload.js';
export const updateFacetAutoSelection = createAction('facet/updateFacetAutoSelection', (payload) => validatePayload(payload, {
    allow: new BooleanValue({ required: true }),
}));
